// src/utils/businessInputs.js
//
// The organization's own business figures for the executive metric layer —
// eligible employees, loaded labour cost, absence days, turnover, EAP
// utilization, an indicative program cost and the attribution dial — live on
// organizations/{orgId}.businessInputs. Org admins and the super admin can
// write the org doc (firestore.rules); everyone in the org reads it through
// OrganizationContext, so the console picks a save up live.

import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase-config';

export const BUSINESS_INPUT_KEYS = ['eligibleEmployees', 'loadedLabourCost', 'absenceDays', 'turnoverRate', 'efapUtilization', 'programPEPM', 'attribution'];
export const BENCHMARK_TOGGLE_KEYS = ['absenceDays', 'turnoverRate', 'efapUtilization'];

export const readBusinessInputs = (orgData) => (orgData && orgData.businessInputs) || {};

// Persist the whole map (replace, not merge) so a cleared field really clears.
export const saveBusinessInputs = async (orgId, inputs, user) => {
    if (!orgId) throw new Error('No organization selected.');
    const clean = {};
    BUSINESS_INPUT_KEYS.forEach((k) => {
        const n = parseFloat(inputs[k]);
        if (Number.isFinite(n)) clean[k] = n;
    });
    clean.useBenchmark = {};
    BENCHMARK_TOGGLE_KEYS.forEach((k) => { clean.useBenchmark[k] = !!(inputs.useBenchmark && inputs.useBenchmark[k]); });
    clean.updatedAt = new Date().toISOString();
    clean.updatedBy = (user && (user.email || user.uid)) || null;
    await updateDoc(doc(db, 'organizations', orgId), { businessInputs: clean });
    return clean;
};
